export default __webpack_public_path__ + "static/media/2.35b6c4dd.webp";